export const unitsdata = [
	{
		"id":1,
		"unit": "Piece",
		"shortname": "PC",
		"noofproducts": "25",
		"createdon": "25 May 2023",
		"status": "Active",
		
	},
	{
        "id":2,
		"unit": "Kilogram",
		"shortname": "KG",
		"noofproducts": "15",
		"createdon": "24 Jun 2023",
		"status": "Active",
		
	},
	{
        "id":3,
		"unit": "Gram",
		"shortname": "G",
		"noofproducts": "47",
		"createdon": "23 Jul 2023",
		"status": "Active",
		
	},
	{
        "id":4,
		"unit": "Meter",
		"shortname": "M",
		"noofproducts": "28",
		"createdon": "22 Aug 2023",
		"status": "Active",
		
	},
	{
        "id":5,
		"unit": "Liter",
		"shortname": "L",
		"noofproducts": "47",
		"createdon": "21 Sep 2023",
		"status": "Active",
		
	},
	{
        "id":6,
		"unit": "Kilo",
		"shortname": "K",
		"noofproducts": "74",
		"createdon": "20 Sep 2023",
		"status": "Active",
		
	}
]